export const days = [...Array(31).keys()];

export const years = [];
for (var curYear = (new Date()).getFullYear(), j = curYear; j >= (curYear - 120); j--) {
  years.push(j);
}

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const months = monthNames.map((string, index) => ({
  name: string,
  number: index + 1,
  twoDigits: index + 1 < 10 ? `0${index + 1}` : `${index + 1}`,
}));

export const getUTCDate = (dateString = Date.now()) => {
  const date = new Date(dateString);
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );
};
